/* Front Line pistol search (type "glock 19" -> pick). Used by the homepage strip (navigate to the finder) and by
   collection pages (remember the pistol in place). Markup: snippets/fl-gun-search.liquid. Data: fitment-index.json. */
(function () {
  if (!window.FLGun) return;
  var idxP = null, entries = null;
  function load() {
    if (!idxP) idxP = fetch(FLGun.indexUrl, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (idx) {
      entries = [];
      idx.brands.forEach(function (b, bi) { b.m.forEach(function (m) { entries.push({ b: b.n, d: b.d, l: m.l, bi: bi, key: norm(b.d + ' ' + b.n + ' ' + m.l) }); }); });
      return idx;
    }).catch(function () { return null; });
    return idxP;
  }
  function norm(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mount(root) {
    if (root.__flgs) return; root.__flgs = 1;
    var input = root.querySelector('input'), list = root.querySelector('ul'), mode = root.getAttribute('data-mode') || 'navigate';
    function pick(b, l) {
      var g = { b: b, l: l }; FLGun.set(g, root.getAttribute('data-via') || (mode === 'navigate' ? 'search_home' : 'search'));
      if (mode === 'navigate') location.href = FLGun.finderUrl(g, 'step=carry');
      else { list.hidden = true; input.value = ''; input.blur(); }
    }
    function show() {
      var raw = input.value.trim();
      if (!raw || !entries) { list.hidden = true; list.innerHTML = ''; return; }
      var toks = raw.toLowerCase().split(/\s+/).map(norm).filter(Boolean), joined = norm(raw);
      var hits = entries.filter(function (e) { return e.key.indexOf(joined) > -1 || toks.every(function (t) { return e.key.indexOf(t) > -1; }); })
        .sort(function (a, b) { return a.bi - b.bi || a.l.localeCompare(b.l, 'en', { numeric: true }); }).slice(0, 7);
      list.innerHTML = hits.length ? hits.map(function (e, i) { return '<li><button type="button" role="option" aria-selected="' + (i === 0) + '" data-b="' + esc(e.b) + '" data-l="' + esc(e.l) + '">' + esc(e.d + ' ' + e.l) + '</button></li>'; }).join('')
        : '<li><button type="button" disabled>No match. Try the brand, e.g. "Glock".</button></li>';
      list.hidden = false;
    }
    input.addEventListener('focus', function () { load().then(show); }, { once: false });
    input.addEventListener('input', function () { load().then(show); });
    input.addEventListener('keydown', function (e) {
      var opts = Array.prototype.slice.call(list.querySelectorAll('[data-b]')); if (!opts.length) return;
      var i = opts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); opts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); }); i = (i + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length; opts[i].setAttribute('aria-selected', 'true'); }
      if (e.key === 'Enter') { e.preventDefault(); var o = opts[Math.max(0, i)]; pick(o.getAttribute('data-b'), o.getAttribute('data-l')); }
      if (e.key === 'Escape') { list.hidden = true; }
    });
    list.addEventListener('click', function (e) { var o = e.target.closest('[data-b]'); if (o) pick(o.getAttribute('data-b'), o.getAttribute('data-l')); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) list.hidden = true; });
  }
  function scan(scope) { (scope || document).querySelectorAll('[data-flgs]').forEach(mount); }
  window.FLGunSearch = { mount: mount, scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
})();
